import React, { ReactElement } from "react";

const icons: { [type: string]: ReactElement } = {
  text: (
    <svg
      fill="currentColor"
      className="inline-block relative bottom-0.5"
      style={{ width: "14px", height: "6px" }}
      width="14"
      height="6"
      viewBox="0 0 14 6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h7v2H0V0zM9 0h5v2H9V0zM0 4h3v2H0V4zM5 4h9c0 1.10457-.8954 2-2 2H5V4z"></path>
    </svg>
  ),
  "yes-no": (
    <svg
      fill="currentColor"
      className="inline-block relative bottom-0.5"
      style={{ width: "17px", height: "17px" }}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.13086.368561C3.71236.368561.130859 3.95006.130859 8.36856c0 4.41854 3.581501 8.00004 8.000001 8.00004 4.41854 0 8.00004-3.5815 8.00004-8.00004 0-4.4185-3.5815-7.999999-8.00004-7.999999zm0 14.500039c-3.584 0-6.5-2.916-6.5-6.50004 0-3.584 2.916-6.5 6.5-6.5V14.8686z"></path>
    </svg>
  ),
  "multiple-choice": (
    <svg
      fill="currentColor"
      className="inline-block relative bottom-0.5"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      cursor="unset"
    >
      <path
        d="M3.5 3.329 3.022 4.5h.956zM4.589 6l.216.532a.75.75 0 0 0 1.39-.566l-1.77-4.346a.998.998 0 0 0-1.85 0L.806 5.967a.75.75 0 1 0 1.39.566l.216-.532zM1.47 9.22A.75.75 0 0 1 2 9h2.303C5.38 9 6 9.896 6 10.79c0 .328-.084.657-.244.941.309.349.494.81.494 1.309 0 1.071-.852 1.96-1.946 1.96L2 15a.75.75 0 0 1-.75-.75v-4.5c0-.199.079-.39.22-.53m2.833 1.857c.04 0 .065-.008.08-.014a.13.13 0 0 0 .045-.035.36.36 0 0 0 .072-.24.36.36 0 0 0-.072-.239.13.13 0 0 0-.045-.034.2.2 0 0 0-.08-.014H2.75v.576zm-1.553 1.5h1.553a.45.45 0 0 1 .447.462c0 .266-.203.46-.447.46H2.75z"
        fillRule="evenodd"
        clipRule="evenodd"
      ></path>
      <path d="M8.75 3.498a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM8.75 11.503a.75.75 0 1 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"></path>
    </svg>
  ),
  "opinion-scale": (
    <svg
      fill="currentColor"
      className="inline-block relative bottom-0.5"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      cursor="unset"
    >
      <g clipPath="url(#349__a)">
        <path
          d="M8.233 1.665a.25.25 0 0 0-.467 0l-1.34 3.513a1.75 1.75 0 0 1-1.496 1.12l-3.194.256a.25.25 0 0 0-.141.44L4.013 9.03a1.75 1.75 0 0 1 .575 1.741l-.808 3.423a.25.25 0 0 0 .373.27l2.937-1.788a1.75 1.75 0 0 1 1.82 0l2.937 1.789a.25.25 0 0 0 .373-.271l-.809-3.423a1.75 1.75 0 0 1 .576-1.74l2.418-2.037a.25.25 0 0 0-.14-.44l-3.196-.256a1.75 1.75 0 0 1-1.495-1.12zM6.365 1.13c.573-1.5 2.697-1.5 3.27 0l1.34 3.513a.25.25 0 0 0 .214.16l3.195.255c1.559.125 2.184 2.076.987 3.083l-2.418 2.037a.25.25 0 0 0-.082.248l.809 3.423c.357 1.512-1.287 2.705-2.614 1.897L8.13 13.957a.25.25 0 0 0-.26 0l-2.936 1.789c-1.327.808-2.971-.385-2.614-1.897l.809-3.423a.25.25 0 0 0-.083-.248L.628 8.14c-1.196-1.007-.57-2.958.988-3.083l3.195-.255a.25.25 0 0 0 .213-.16z"
          fillRule="evenodd"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="349__a">
          <path d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  number: (
    <svg
      fill="currentColor"
      className="inline-block relative bottom-0.5"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      cursor="unset"
    >
      <path
        d="M5.75 1.006a.75.75 0 0 1 .65.837L6.13 4h4.74l.292-2.343a.75.75 0 0 1 1.488.186L12.38 4h1.87a.75.75 0 0 1 0 1.5h-2.057l-.625 5h2.682a.75.75 0 1 1 0 1.5h-2.87l-.292 2.343a.75.75 0 0 1-1.488-.186L9.87 12H5.13l-.292 2.343a.75.75 0 0 1-1.488-.186L3.62 12H1.75a.75.75 0 0 1 0-1.5h2.057l.625-5H1.75a.75.75 0 0 1 0-1.5h2.87l.292-2.343a.75.75 0 0 1 .837-.651M5.942 5.5l-.625 5h4.739l.625-5z"
        fillRule="evenodd"
        clipRule="evenodd"
      ></path>
    </svg>
  ),
  ranking: (
    <svg
      fill="currentColor"
      className="inline-block relative bottom-0.5"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      cursor="unset"
    >
      <path d="M8.75 3.498a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zM8.75 11.503a.75.75 0 1 0 0 1.5h5.5a.75.75 0 0 0 0-1.5z"></path>
      <path
        d="M2.5 10.52A.75.75 0 0 1 1 10.5c0-.276.051-.566.21-.825.164-.27.4-.433.636-.528.221-.088.45-.12.64-.133C2.67 9 2.87 9 3.045 9h.03c.177 0 .377 0 .563.014.19.014.418.045.639.133.236.095.472.258.637.528.158.259.21.548.21.825v.75a.75.75 0 0 1-.186.494L3.403 13.5H4.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.564-1.244l2.439-2.788v-.448l-.097-.01a7 7 0 0 0-.466-.01c-.195 0-.34 0-.466.01zM3.602 1.088A.75.75 0 0 1 4 1.75v4.5a.75.75 0 1 1-1.5 0V3.162l-.33.223a.75.75 0 0 1-.84-1.243l1.5-1.013a.75.75 0 0 1 .772-.041"
        fillRule="evenodd"
        clipRule="evenodd"
      ></path>
    </svg>
  ),
  matrix: (
    <svg
      fill="currentColor"
      className="inline-block relative bottom-0.5"
      style={{ width: "16px", height: "14px" }}
      width="16"
      height="14"
      viewBox="0 0 20 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 8.75H1.752l-.002 6.73c0 .165.128.27.25.27h8v-7c0 .165.122 0 0 0h8.25v-7h-8.248l-.002 7zM.005 0L0 15.48a2.01 2.01 0 002 2.02h16c1.105 0 2-.904 2-2.02V0H.005z"
      ></path>
    </svg>
  ),
};

interface QuestionTypeIconProps {
  type: string;
}

const QuestionTypeIcon: React.FC<QuestionTypeIconProps> = ({ type }) => {
  return (
    <span
      className="bg-[#38bdf9] rounded px-1 inline-block"
      title={`Question type: ${type}`}
    >
      {icons[type]}
    </span>
  );
};

export default QuestionTypeIcon;
